// extracted by css-extract-rspack-plugin
export default {"description":"DateTimeInputDialog_description__K5+tV"};